import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navItems = [
  ["HOME", "/", "nav-link-home", true],
  ["SOURCE", "/source", "nav-link-source", false],
  ["CONNECT", "/connect", "nav-link-connect", false],
  ["FACILITATE", "/facilitate", "nav-link-facilitate", false],
  ["EXPAND", "/expand", "nav-link-expand", false],
  ["FOCUS AREAS", "/focus-areas", "nav-link-focus-areas", false],
  ["INSIGHTS", "/insights", "nav-link-insights", false],
];

export default function Header({ onEnquiry }) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header data-testid="ugi-header-nav" className="sticky top-0 z-40 border-b border-[#E5DFD3]/80 bg-[#FDFBF7]/90 backdrop-blur-xl">
      <div className="mx-auto flex h-24 max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" data-testid="ugi-logo-link" aria-label="UGI home" className="flex items-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059]">
          <img src="/assets/ugi-official-logo-web.png" alt="Unity Gateway International LLP" className="h-16 w-auto object-contain" />
        </Link>

        <nav aria-label="Primary navigation" className="hidden items-center gap-5 lg:flex xl:gap-7">
          {navItems.map(([label, href, testId, end]) => (
            <NavLink key={label} data-testid={testId} to={href} end={end} className={({ isActive }) => `relative pb-2 text-[11px] font-semibold tracking-[0.18em] transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059] ${isActive ? "text-[#1C1613] after:absolute after:bottom-0 after:left-0 after:h-px after:w-full after:bg-[#C5A059]" : "text-[#524842] hover:text-[#1C1613]"}`}>
              {label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button data-testid="nav-contact-button" onClick={onEnquiry} className="hidden border border-[#1C1613] px-5 py-3 text-[11px] font-bold tracking-[0.16em] transition-colors hover:bg-[#1C1613] hover:text-[#FDFBF7] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#C5A059] sm:inline-flex">
            START AN ENQUIRY
          </button>
          <button data-testid="mobile-menu-button" onClick={() => setMenuOpen(!menuOpen)} aria-expanded={menuOpen} aria-controls="mobile-navigation" aria-label="Toggle navigation menu" className="inline-flex h-11 w-11 items-center justify-center border border-[#E5DFD3] lg:hidden">
            {menuOpen ? <X size={20} strokeWidth={1.5} /> : <Menu size={20} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav id="mobile-navigation" aria-label="Mobile navigation" className="border-t border-[#E5DFD3] bg-[#FDFBF7] px-5 py-5 lg:hidden">
          <div className="grid gap-4">
            {navItems.map(([label, href, testId, end]) => (
              <NavLink key={label} data-testid={`${testId}-mobile`} to={href} end={end} onClick={() => setMenuOpen(false)} className={({ isActive }) => `border-l-2 py-1 pl-4 text-sm font-semibold tracking-[0.18em] transition-colors ${isActive ? "border-[#C5A059] text-[#1C1613]" : "border-transparent text-[#524842]"}`}>
                {label}
              </NavLink>
            ))}
            <button data-testid="mobile-contact-button" onClick={onEnquiry} className="mt-2 bg-[#1C1613] px-5 py-4 text-left text-xs font-bold tracking-[0.16em] text-[#FDFBF7]">
              START AN ENQUIRY
            </button>
          </div>
        </nav>
      )}
    </header>
  );
}
